import { siteDerived } from '@/constants/siteDerived'

const _build = (site) => ({
  META: {
    PRODUCT: site.pageRoot + 'catalog/meta/product/{0}/{1}',
    CUSTOMER_REVIEWS:
      site.pageRoot + 'meta/reviews/{0}?onlyWithText={1}&sort={2}&page={3}',
    CROSS_SELLS: site.pageRoot + 'catalog/meta/cross-sells/{0}/{1}'
  }
})

/** @type {ReturnType<typeof _build>} */
export const PDP_REQUEST_URL = siteDerived(_build)
